import { useDispatch } from 'react-redux'
import { showAlert } from '../../redux/reducers/alertSlice'
import api from '../../../_metronic/helpers/api';
import { useNavigate } from 'react-router-dom';

export default function useUtils() {
   const dispatch = useDispatch()  
   const navigate = useNavigate()
    
   const fetchLanguages = async (limit=10, offset=0) => {
    try {
      const response = await api.get(`/language`, {
        params: {
          limit,
          offset
        },
      });
      if (response.data.status) {
      return response.data.data
      }
    } catch (error) {
        console.log(error?.response?.data?.message)
    }
  };

  const submitLanguage = async (values) => {
    try {
      const response = await api.post(`/language`, values);
      if (response.data.status) {
        dispatch(
          showAlert({
            message: "Language Successfully added",
            variant: "success",
          })
        );
        navigate('/languagelist')
      } else {
        dispatch(
          showAlert({ message: response.data.message, variant: "danger" })
        );
      }
    } catch (error) {
      dispatch(
        showAlert({ message: error.response.data.message, variant: "danger" })
      );
    }
  };

  const deleteLanguage=async(id, limit, offset)=>{
    try {
      const response = await api.delete(`/language/${id}`);
        if(response.data.status){
          dispatch(showAlert({message:`Language Deleted`, variant:'success', timeout:'2000'}))
          return fetchLanguages(limit, offset)
        }
     } catch (error) {
        dispatch(showAlert({message:error?.response?.data?.message, variant:'danger'}))
     }
  }

  const handleEdit = async (name,code, id, onHide, limit, offset) => {
    try {
      const response = await api.patch(`/language/${id}`, {name, code});
      if (response.data.status) {
        onHide()
       
        dispatch(
          showAlert({
            message: `Language Modified`,
            variant: "success",
            timeout: "2000",
          })
        )
        return fetchLanguages(limit, offset)
      }
    } catch (error) {
        dispatch(
            showAlert({
              message:error?.response?.data?.message,
              variant: "danger",
              timeout: "2000",
            })
          )
       }
  };

  const makeDefault = async (values, limit, offset) => {
    try {
      const response = await api.patch(`/language/${values?.id}`, {isDefault:true});
      if (response.data.status) {
        dispatch(
          showAlert({
            message: `${values?.name} is now the default language`,
            variant: "success",
            timeout: "2000",
          })
        )
       return fetchLanguages(limit, offset)
      }
    } catch (error) {
        dispatch(
            showAlert({
              message:error?.response?.data?.message || 'Network Error',
              variant: "danger",
              timeout: "2000",
            })
          )
       }
  };

   return {handleEdit, makeDefault, submitLanguage, fetchLanguages, deleteLanguage}
}
